module.exports = __webpack_public_path__ + "images/stickers/taco-proto.7da9fba37d80d3bae59d.png";